export interface SleepingPlace {
    id: number;
    name?: any;
    isAdditional: boolean;
    isCustom: boolean;
    count: number;
    isExtraCharge?: any;
    defaultName: string;
}

export interface Photo {
    id: number;
    name: string;
    url: string;
    isTitle?: any;
}

export interface Facility {
    id: number;
    name: string;
    groupId: number;
    groupName: string;
    hit: string;
}

export interface Room {
    id: number;
    name: string;
    lName?: any;
    description?: string;
    roomCount?: any;
    defaultPersonCount?: number;
    maxPersonCount?: number;
    area?: number;
    isRangeArea?: any;
    minArea?: any;
    maxArea?: any;
    sleepingPlaces: SleepingPlace[];
    photos: Photo[];
    facilities: Facility[];
}

export interface RoomsResponse {
    result: Room[];
    error?: any;
}

export enum FacilityGroup {
    Bathroom = 1,
    Technical = 2,
    Bath = 3,
    Balcony = 4,
    Furniture = 5,
    Special = 6,
    View = 7,
}
